export default __webpack_public_path__ + "static/media/expand.86803ca2.svg";